import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as userActions from '../actions/user.actions';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import jwt_decode from 'jwt-decode';

@Injectable()
export class UserEffects {
    initUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(userActions.UserActionTypes.initUser),
            switchMap(() => {
                const userAccount = localStorage.getItem('userAccount');
                if (userAccount !== null) {
                    return [userActions.GetUserSuccess(JSON.parse(userAccount).data), userActions.GetUser({ userId: JSON.parse(userAccount)._id })];
                }
                let token: any = localStorage.getItem('token');
                token = jwt_decode(token);
                return of(userActions.GetUser({ userId: token._id }));
            })
        )
    );

    getuser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(userActions.UserActionTypes.getUser),
            switchMap((action: { userId: string }) =>
                this.authService.getUserAccount(action.userId).pipe(
                    switchMap((res: any) => {
                        return of(userActions.GetUserSuccess(res));
                    }),
                    catchError((error: any) => of(userActions.GetUserFailures(error)))
                )
            )
        )
    );

    constructor(public toastService: ToastrService, private actions$: Actions, private authService: AuthService) {}
}
